export default class Queue {
    constructor(size) {
        this.array = [];
        this.size = size;
    }
    add(data) {
        this.array.push(data);
        while (this.array.length > this.size) {
            this.removeFirst();
        }
    }
    removeFirst() {
        if (this.isEmpty()) {
            return undefined;
        }
        return this.array.shift();
    }
    peek() {
        if (this.isEmpty()) {
            return undefined;
        }
        return this.array[0];
    }
    isEmpty() {
        return this.array.length === 0;
    }
    copyArray() {
        return Object.assign([], this.array);
    }
    lastn(n) {
        const arr = Object.assign([], this.array);
        return arr.length <= n ? arr : arr.splice(arr.length - n);
    }
}
